import React from "react";
import "./shell.css";

export default function DesktopShell({ children }) {
  return (
    <div className="app-shell app-shell--desktop">
      <main className="app-shell__content app-shell__content--desktop">{children}</main>
    </div>
  );
}
